export const getExternalDeletedItems = ({ externalItemsIds, feedOptions, itemId }) => {
  const deletedExternalItems = []

  if (externalItemsIds !== null && externalItemsIds !== undefined) {
    externalItemsIds.forEach(singleItemId => {
      const availableExternalElements =
        itemId === 'ExternalProductIds'
          ? feedOptions.find(opt => opt[itemId].includes(singleItemId))
          : feedOptions.find(opt => opt[itemId] === singleItemId)

      if (typeof availableExternalElements === 'undefined') {
        deletedExternalItems.push(singleItemId)
      }
    })

    return deletedExternalItems
  }
}

export const deletedExternalItemErrorFormatter = ({ deletedExternalItems, source }) => {
  if (typeof deletedExternalItems === 'undefined' || deletedExternalItems.length === 0) return null

  const verb = deletedExternalItems.length > 1 ? 'are' : 'is'
  const noun =
    source === 'products'
      ? deletedExternalItems.length > 1
        ? 'products'
        : 'product'
      : deletedExternalItems.length > 1
      ? 'resources'
      : 'resource'

  return `Previously linked ${noun} (${deletedExternalItems.join(', ')}) ${verb} deleted`
}
